<template lang="es">
<div class="profile">
    <Navigation></Navigation>

    <div class="container add_top_30 add_bottom_30">
        <div class="row">
			
            <div class="col col-lg-3">
                <ProfileSidebar></ProfileSidebar>
            </div>
            
            <div class="col-md-12 col-lg-9" v-if="loading" >
                <Loader :show="loading" type="inline"></Loader>
            </div>

			<div class="col-md-12 col-lg-9" v-if="!loading" >
                <div class="container box_general">
                    <div class="header_box">
                        <h2><i class="pe-7s-date"></i>Reserva #{{booking.code}}</h2>
                        <h4>
                            <span class="badge badge-success" v-if="booking.status=='CONFIRMED'">Confirmada</span>
                            <span class="badge badge-success" v-if="booking.status=='VIDEO_LIVE'">VideoConsulta en curso</span>
                            <span class="badge badge-light" v-if="booking.status=='DONE' || booking.status=='VIDEO_ENDED'">Realizada</span>
                        </h4>
                    </div>

                    <div class="row" >
                        <div class="col-12">
                            <!-- <Chat v-if="!$route.query.vonage" :booking="booking" @callEnded="$apollo.queries.me.refresh()"/> -->
                            <!-- <ChatVonage v-if="$route.query.vonage" :booking="booking" @callEnded="$apollo.queries.me.refresh()"/> -->
                            <ChatVonage  :booking="booking" @callEnded="$apollo.queries.me.refresh()"/>
                        </div>
                    </div>

                    <div class="row" >
                        
                        <div class="col-md-8" >
                            <div class="book-data" >
                                <div class="box">
                                    <div class="subtitle">ESPECIALIDAD</div>
                                    <div class="value">
                                        {{booking.medicEspeciality.especiality.name }}
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="subtitle">FECHA Y HORA</div>
                                    <div class="value">
                                        <div class="date">{{booking.timeslot.datetime | moment("dddd DD [de] MMMM HH:mm")}}</div>
                                    </div>
                                </div>
                                

                                <div class="box">
                                    <div class="subtitle">Costo de la consulta</div>
                                    <div class="value">
                                        $ {{booking.price}}
                                    </div>
                                </div>
                                <div class="box" v-if="booking.comments">
                                    <div class="subtitle">HISTORIA</div>
                                    <div class="value">
                                        <p>{{booking.comments}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="medic-info">
                                <figure class="mb-3">
                                    <div class="avatar" v-if="booking.medic.picture" :style="'background-image:url('+API_URL+booking.medic.picture.url+')'"></div>
                                    <div class="avatar" v-if="!booking.medic.picture && booking.medic.gender=='female'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-female.jpg')+')'"></div>
                                    <div class="avatar" v-if="!booking.medic.picture && booking.medic.gender=='male'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-male.jpg')+')'"></div>
                               </figure>
                                
                                <div class="especialities">
                                    <small  v-for="medicEspeciality in booking.medic.medicEspecialities" :key="medicEspeciality.id">
                                        {{medicEspeciality.especiality.name}}
                                    </small>
                                </div>
                                
                                <h1>{{booking.medic.fullname}}</h1>
                            </div>
                        </div>

                        
                        <hr>

                        <div class="col-12">
                            <router-link tag="button" class="btn btn-sm pull-left" to="/bookings">Volver</router-link>
                        </div>
                    </div>


                </div>

            </div>

        </div>
        
    </div>
    

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import Navigation from '@/components/Navigation'
import ProfileSidebar from '@/components/ProfileSidebar'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'
// import Chat from '@/components/Chat'
import ChatVonage from '@/components/ChatVonage'

export default {
	name: 'bookingAttend',
	metaInfo() {
		return {
			title: 'Reserva # ' + this.booking.code,
		}
	},
	components: {
		Navigation,
		Footer,
		Loader,
		ProfileSidebar,
		// Chat,
		ChatVonage,
	},
	data() {
		return {
			action: this.$route.query.action,
			loading: true,
			booking: {},
			API_URL: process.env.VUE_APP_API_URL,
		}
	},
	computed: {
		...mapGetters(['isAuthenticated', 'loggedUser']),
	},
	methods: {},
	apollo: {
		me: {
			query: gql`
				query meBooking($id: ID!) {
					me {
						booking(id: $id) {
							id
							code
							price
							status
							comments
							user {
								email
							}
							medicEspeciality {
								title
								especiality {
									name
									slug
								}
							}
							medic {
								id
								fullname
								prefix
								gender
								picture {
									url
								}
								medicEspecialities {
									id
									title
									especiality {
										name
										slug
									}
								}
								rate
							}
							timeslot {
								datetime
								status
							}
							is_donated
						}
					}
				}
			`,
			fetchPolicy: 'no-cache',
			variables() {
				return {
					id: this.$route.params.id,
				}
			},
			result(data) {
				this.booking = data.data.me.booking[0]
				if (!this.booking) {
					this.$router.push('/bookings')
				}
				this.loading = false
			},
		},
	},
}
</script>

<style scoped>
.book-data {
	width: 100%;
}
.book-data .box {
	padding: 12px 8px;
}
.book-data .box:not(:last-child) {
	border-bottom: solid 1px #ededed;
}
.book-data .box .subtitle {
	font-size: 12px;
	text-transform: uppercase;
	color: #666;
}
.book-data .box .value {
	font-size: 18px;
	text-transform: capitalize;
	line-height: 18px;
}
.book-data .box .value p {
	font-size: 14px;
	text-transform: none;
	line-height: 14px;
}

.medic-info {
	border-left: solid 1px #ededed;
	padding: 18px;
	text-align: center;
}
.medic-info figure {
	width: 90px;
	margin: auto;
	border-radius: 45px;
	overflow: hidden;
}

.medic-info .rating {
	margin-bottom: 20px;
	display: inline-block;
}

.medic-info small {
	text-transform: uppercase;
	color: #999;
	font-weight: 600;
}

.medic-info h1 {
	font-size: 18px;
}

.actions-box {
	border-top: 1px solid #ededed;
	width: 100%;
	padding: 12px 8px;
}

.payments {
}
.payments li {
	width: 100%;
	padding: 8px;
	border-bottom: solid 1px #ededed;
	display: flex;
	align-items: center;
}
.payments .brand-logo {
	margin-right: 8px;
	max-width: 120px;
}

.payments h2 {
	font-size: 14px;
	font-weight: 600;
	margin: 0px;
}
.payments h3 {
	font-size: 14px;
	font-weight: 400;
	margin: 0px;
	color: #666;
}
.payments h3 span {
	font-weight: 400;
}
.payments .date {
	flex-grow: 1;
	text-align: right;
	color: #999;
	font-size: 12px;
}
</style>
